
import HeroBanner from '../components/HomeBanner';
import AstrologerSlides from '../components/AstrologerSlides';
import CourseSlide from '../components/CourseSlide';
import HomeImageCarousel from '../components/HomeImageCarousel'; 
import GosevaGallery from '../components/GosevaGallery';
import TestimonialCarousel from '../components/TestimonialCarousel';
import YoutubeSlider from "../components/YoutubeSlider";

import './Home.css';


import aries from '../assets/zodiac/Aries.jpg';
import taurus from '../assets/zodiac/Taurus.jpg';
import gemini from '../assets/zodiac/Gemini.jpg';
import cancer from '../assets/zodiac/Cancer.jpg';
import leo from '../assets/zodiac/Leo.jpg';
import virgo from '../assets/zodiac/Virgo.jpg';
import libra from '../assets/zodiac/Libra.jpg';
import scorpio from '../assets/zodiac/Scorpio.jpg';
import sagittarius from '../assets/zodiac/Sagittarius.jpg';
import capricorn from '../assets/zodiac/Capricorn.jpg';
import aquarius from '../assets/zodiac/Aquarius.jpg';
import pisces from '../assets/zodiac/Pisces.jpg';

function Home() {
  return (
    <div className="home-page">
        <HeroBanner />


        <div className="services-section">
            <h2 className="section-title">Services Offered</h2>
            <div className="services-grid">
                <a href="/services/astro-vastu" className="service-card">Astro Vastu</a>
                <a href="/services/astrology" className="service-card">Astrology</a>
                <a href="/services/matchs-making" className="service-card">Match Making</a>
                <a href="/services/career-prediction" className="service-card">Career Prediction</a>
                <a href="/services/health-astrology" className="service-card">Health Astrology</a>
                <a href="/services/love-astrology" className="service-card">Love Astrology</a>
                <a href="/services/muhurta" className="service-card">Muhurta</a>
                <a href="/services/wealth-astrology" className="service-card">Wealth Astrology</a>
                <a href="/services/astro-vastu" className="service-card">Vastu</a>
                <a href="/services/litigation" className="service-card">Litigation</a>
            </div>
         </div>


         <div className="zodiac-section">
            <h2 className="section-title">Zodiac Signs: Learn The Names And Symbols</h2>
            <p className="zodiac-subtitle">
                Welcome to a world where the ancient wisdom of the stars illuminates the path to understanding ourselves.
            </p>

            <div className="zodiac-grid">
                <div className="zodiac-card"><img src={aries} alt="Aries" /><p>Aries</p></div>
                <div className="zodiac-card"><img src={taurus} alt="Taurus" /><p>Taurus</p></div>
                <div className="zodiac-card"><img src={gemini} alt="Gemini" /><p>Gemini</p></div>
                <div className="zodiac-card"><img src={cancer} alt="Cancer" /><p>Cancer</p></div>
                <div className="zodiac-card"><img src={leo} alt="Leo" /><p>Leo</p></div>
                <div className="zodiac-card"><img src={virgo} alt="Virgo" /><p>Virgo</p></div>
                <div className="zodiac-card"><img src={libra} alt="Libra" /><p>Libra</p></div>
                <div className="zodiac-card"><img src={scorpio} alt="Scorpio" /><p>Scorpio</p></div>
                <div className="zodiac-card"><img src={sagittarius} alt="Sagittarius" /><p>Sagittarius</p></div>
                <div className="zodiac-card"><img src={capricorn} alt="Capricorn" /><p>Capricorn</p></div>
                <div className="zodiac-card"><img src={aquarius} alt="Aquarius" /><p>Aquarius</p></div>
                <div className="zodiac-card"><img src={pisces} alt="Pisces" /><p>Pisces</p></div>
            </div>
        </div>

       <AstrologerSlides />

         <GosevaGallery />
         

         <HomeImageCarousel />

         
         <TestimonialCarousel />

            <div>
              <h2>Latest Videos</h2>
              <YoutubeSlider />
            </div>


                
    </div>
  );
}
export default Home;
